export const getToaster = () => window.toastr
export const renderLeftMenu = (...args) => window.renderLeftMenu(...args)